package com.exura.features.fileStorage.usecase

import com.exura.features.fileStorage.domain.repository.UserFileStorageRepository
import dev.gitlive.firebase.storage.StorageReference


class ListFilesUseCase(
    private val fileStorageRepository: UserFileStorageRepository,
) {
    suspend operator fun invoke(path: String): Result<List<StorageReference>> =
        fileStorageRepository.fetchFiles(path)
}
